export default __webpack_public_path__ + "static/media/nutritionCare.b112df00.svg";